// Converts the input string decimal value into a numeric amount
// for use with stripe. Returns null for invalid inputs
export const useStripeAmount = inputStr => {
  // Ensure the that input is numeric and has no more than 2 decimal places
  if (!/^\d*(\.\d{0,2})?$/.test(inputStr)) {
    return null;
  }

  const parsedAmount = Number(inputStr);
  if (Number.isNaN(parsedAmount)) {
    return null;
  }
  // convert from dollars to cents
  return Math.round(parsedAmount * 100);
};
